import React from "react";
import LanguageToggle from "../components/LanguageToggle";
import { useTranslation } from "react-i18next";
import "./Layout.css";

export default function Layout({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="h-full">
      <header className="header">
        <nav className="flex justify-between items-center">
          <span className="site-title">
            {t("stockholm_cultural_workers_for_palestine")}
          </span>
          <ul className="header-list">
            <li>
              {" "}
              <a
                className="menu-link"
                href={process.env.REACT_APP_GOOGLE_FORM_URL!}
                target="_blank"
                rel="noreferrer"
              >
                {t("sign")}
              </a>
            </li>
            <li>
              <LanguageToggle />
            </li>
          </ul>
        </nav>
      </header>
      <main className="min-h-full">{children}</main>
      {/* <Footer /> */}
    </div>
  );
}
